import { type BadgeColor, Empty, Flex, IconBadge } from "@zfp-akademie-a-s/zfp-design";
import { CheckCircleIcon, InfoIcon, WarningIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { NsureClientCaseStateCaseStatus } from "Infrastructure/ApiZfp/Schema";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import type { ResourcePathType } from "Infrastructure/Translations/Resources";

type Props = {
  caseStatus: NsureClientCaseStateCaseStatus | null;
};

type StatusConfig = {
  titleKey: ResourcePathType;
  icon: React.ReactElement;
  color: BadgeColor;
};

const statusConfigs: Partial<Record<Exclude<NsureClientCaseStateCaseStatus, null>, StatusConfig>> = {
  [NsureClientCaseStateCaseStatus.InSignature]: {
    titleKey: Resources.Questionnaire.InvestmentCaseStatus.StatusTitles.InSignature,
    icon: <InfoIcon sx={{ fontSize: 35 }} />,
    color: "info",
  },
  [NsureClientCaseStateCaseStatus.Signed]: {
    titleKey: Resources.Questionnaire.InvestmentCaseStatus.StatusTitles.Signed,
    icon: <CheckCircleIcon sx={{ fontSize: 35 }} />,
    color: "success",
  },
  [NsureClientCaseStateCaseStatus.Done]: {
    titleKey: Resources.Questionnaire.InvestmentCaseStatus.StatusTitles.Done,
    icon: <CheckCircleIcon sx={{ fontSize: 35 }} />,
    color: "success",
  },
  [NsureClientCaseStateCaseStatus.Rejected]: {
    titleKey: Resources.Questionnaire.InvestmentCaseStatus.StatusTitles.Rejected,
    icon: <WarningIcon sx={{ fontSize: 35 }} />,
    color: "warning",
  },
  [NsureClientCaseStateCaseStatus.Cancelled]: {
    titleKey: Resources.Questionnaire.InvestmentCaseStatus.StatusTitles.Cancelled,
    icon: <WarningIcon sx={{ fontSize: 35 }} />,
    color: "warning",
  },
  [NsureClientCaseStateCaseStatus.Error]: {
    titleKey: Resources.Questionnaire.InvestmentCaseStatus.StatusTitles.Error,
    icon: <WarningIcon sx={{ fontSize: 35 }} />,
    color: "warning",
  },
};

const fallbackConfig: StatusConfig = {
  titleKey: Resources.Questionnaire.InvestmentCaseStatus.Title,
  icon: <WarningIcon sx={{ fontSize: 35 }} />,
  color: "warning",
};

export const InvestmentsNsureCaseStatus = ({ caseStatus }: Props) => {
  const { t } = useResource();

  const config = (caseStatus && statusConfigs[caseStatus]) ?? fallbackConfig;

  return (
    <Flex pt={Spacing.XXL}>
      <Empty
        title={t(config.titleKey)}
        text={t(Resources.Questionnaire.InvestmentCaseStatus.Text)}
        icon={<IconBadge color={config.color} icon={config.icon} />}
      />
    </Flex>
  );
};
